import React, { useEffect, useState } from "react";
import styles from "./AstroContainer.module.scss";
import { Astro_Strings } from "../../Strings";
import AstroCard from "../AstroCard";
import AstroHeader from "../AstroHeader";
import { getRoomFeed } from "../../../../services/rooms.service";
import { generateRoomReqBody } from "../../helper";
import { ROOM_TYPE } from "@/types/common.types";
import {
  AstroCardDataType,
  AstroContainerProps,
  AstroLiveCardDataType,
  RoomResponse,
} from "../../Enum";
import PostCard from "../PostCard";
import { TriggerCallRedirectEvent } from "@/utils/events/events.helpers";
import { EventNames } from "@/utils/events";

const AstroContainer = ({
  liveAstrologers: initialLiveData,
  callAstrologers: initialCallData,
}: AstroContainerProps) => {
  const [liveAstrologers, setLiveAstrologers] = useState<RoomResponse[]>(
    initialLiveData ?? []
  );
  const [callAstrologers, setCallAstrologers] = useState<RoomResponse[]>(
    initialCallData ?? []
  );

  const getLiveAstroLogers = async () => {
    const res = await getRoomFeed(
      {},
      { ...generateRoomReqBody(ROOM_TYPE.LIVE, "Astrology", "All"), size: 5 }
    );

    setLiveAstrologers(res?.data ?? []);
  };

  const getCallAstroLogers = async () => {
    const res = await getRoomFeed(
      {},
      { ...generateRoomReqBody(ROOM_TYPE.CALL, "Astrology", "All"), size: 5 }
    );

    setCallAstrologers(res?.data ?? []);
  };

  const onCardClick = (url: string) => {
    TriggerCallRedirectEvent(EventNames.DeepLink, {
      page: url,
    });
  };

  useEffect(() => {
    if (!initialLiveData || !initialCallData) {
      void getLiveAstroLogers();
      void getCallAstroLogers();
    }
  }, []);

  return (
    <div className={styles.astroContainer}>
      {callAstrologers?.length !== 0 && (
        <>
          <AstroHeader
            title={Astro_Strings.NEED_MORE_GUIDANCE}
            subTitle={Astro_Strings.CONNECT_WITH_ASTROLOGER}
            type={ROOM_TYPE.CALL}
          />
          <AstroCard data={callAstrologers} />
        </>
      )}

      {liveAstrologers?.length !== 0 && (
        <>
          <AstroHeader
            title={Astro_Strings.LIVE_ASTROLOGERS}
            type={ROOM_TYPE.LIVE}
          />

          <div className={styles.liveWrapper}>
            {liveAstrologers?.map((item) => (
              <PostCard
                {...item}
                className={styles.postCardWrapper}
                key={item.liveRoom.id}
                onClick={() => onCardClick(item?.liveRoom?.shareableUrl)}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AstroContainer;
